import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Css/sideBar.css';

function SideBar() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    // Fetch the user's role from local storage or from an API
    const userRole = localStorage.getItem('userRole');
    setRole(userRole);
  }, []);

  return (
    <div className="col-md-3 left_col">
      <div className="left_col scroll-view">
        <div className="navbar nav_title" style={{ border: 0 }}>
          <NavLink to={role === 'District Officer' ? '/district-dashboard' : '/dashboard'} className="site_title">
            <img src="img/ukPolice.png" alt="Logo" />
            {/* <p id="pehchaan" className="text-center text-bold">Pehchan</p> */}
          </NavLink>
        </div>
        <div className="clearfix" />
        <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
          <div className="menu_section">
            <ul className="nav side-menu">


              {/* Show Users menu only if role is Admin or User */}
              {role === 'User' && (
                <>
                  <li>
                    <NavLink to="/dashboardUser" activeClassName="active">
                      <i className="fa fa-home" /> <span className="menu-text">Dashboard</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/profiles" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> <span className="menu-text">Satyapan</span>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/old-profiles" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> Old Satyapan
                    </NavLink>
                  </li> */}
                
                  <li>
                    <NavLink to="/operatorUser" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> <span className="menu-text">App User</span>

                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/settings" activeClassName="active">
                      <i className="fa fa-gear" /> <span className="menu-text">Settings/Profile</span>
                    </NavLink>
                  </li>

                </>

              )}

              {/* show Circle Officer */}
              {role === 'CO' && (
                <>
                  <li>
                    <NavLink to="/dashboardUser" activeClassName="active">
                      <i className="fa fa-home" /> <span className="menu-text">Dashboard</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/profiles" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> <span className="menu-text">Satyapan</span>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/old-profiles" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> Old Satyapan
                    </NavLink>
                  </li> */}
                
                  <li>
                    <NavLink to="/operator-user" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> <span className="menu-text">App User</span>

                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/settings" activeClassName="active">
                      <i className="fa fa-gear" /> <span className="menu-text">Settings/Profile</span>
                    </NavLink>
                  </li>
                </>

              )}

              {/* District Officer menu */}
              {role === 'District Officer' && (
                <>
                  <li>
                    <NavLink to="/district-dashboard" activeClassName="active">
                      <i className="fa fa-home" /> <span className="menu-text">Dashboard</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/district-satyapan" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> <span className="menu-text">Satyapan</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/admin-user" activeClassName="active">
                      <i className="fa fa-address-card" /> <span className="menu-text">Admin User</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/operatorUser" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> <span className="menu-text">App User</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/settings" activeClassName="active">
                      <i className="fa fa-gear" /> <span className="menu-text">Settings/Profile</span>
                    </NavLink>
                  </li>
                
                </>
              )}

              {/* Show Settings/Profile menu only if role is Admin */}
              {role === 'Admin' && (
                <>
                  <li>
                    <NavLink to="/dashboard" activeClassName="active">
                      <i className="fa fa-home" /> <span className="menu-text">Dashboard</span>
                    </NavLink>
                  </li>
                    <li>
                      <NavLink to="/users" activeClassName="active">
                        <i className="fa fa-user-circle-o" /> <span className="menu-text">Satyapan</span>
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink to="/old-users" activeClassName="active">
                        <i className="fa fa-user-circle-o" />Old Satyapan
                      </NavLink>
                    </li> */}
                  <li>
                    <NavLink to="/admin-user" activeClassName="active">
                      <i className="fa fa-address-card" /> <span className="menu-text">Admin User</span>
                    </NavLink>
                  </li>

                  <li>
                    <NavLink to="/operator-user" activeClassName="active">
                      <i className="fa fa-user-circle-o" /> <span className="menu-text">App User</span>

                    </NavLink>
                  </li>
              
                  <li>
                    <NavLink to="/state" activeClassName="active">
                      <i className="fa fa-globe" /> <span className="menu-text">State</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/district" activeClassName="active">
                      <i className="fa fa-map-marker" /> <span className="menu-text">District</span>
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/thana" activeClassName="active">
                      <i className="fa fa-shield" /> <span className="menu-text">Thana</span>
                    </NavLink>
                  </li>
                  {/* <li>
                    <NavLink to="/sro" activeClassName="active">
                      <i className="fa fa-building" /> SRO
                    </NavLink>
                  </li> */}
                  <li>
                    <NavLink to="/settings" activeClassName="active">
                      <i className="fa fa-gear" /> <span className="menu-text">Settings/Profile</span>
                    </NavLink>
                  </li>
               
                </>
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SideBar;
